import type { AccessContext, ModuleManifest, ModuleNavItem, Session } from "@crialume/sdk";

export type AccessDecision =
  | { allowed: true }
  | { allowed: false; reason: "disabled" | "feature-off" | "unauthenticated" | "forbidden" };

/** Regra única de acesso, usada no menu, no redirect inicial e antes de baixar o chunk. */
export function checkModuleAccess(manifest: ModuleManifest, access: AccessContext): AccessDecision {
  if (access.config.disabledModules.includes(manifest.id)) {
    return { allowed: false, reason: "disabled" };
  }

  const features = manifest.requirements?.features ?? [];
  if (!features.every((flag) => access.config.features[flag] === true)) {
    return { allowed: false, reason: "feature-off" };
  }

  if (!access.session) return { allowed: false, reason: "unauthenticated" };

  const required = manifest.requirements?.permissions ?? [];
  const granted = access.session.permissions;
  if (!required.every((permission) => granted.includes(permission))) {
    return { allowed: false, reason: "forbidden" };
  }

  return { allowed: true };
}

export function visibleNavItems(
  manifest: ModuleManifest,
  session: Session | null,
): ModuleNavItem[] {
  return (manifest.nav ?? []).filter(
    (item) => !item.permission || (session?.permissions.includes(item.permission) ?? false),
  );
}
